<script>
import { List, Cell, Col, Row, Image, Icon, Empty } from 'vant'
import { QNImageUtil } from '@/utils'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'org-match-brand-list',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-list': List,
        'van-cell': Cell,
        'van-row': Row,
        'van-col': Col,
        'van-image': Image,
        'van-icon': Icon,
        'van-empty': Empty
    },

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['custom-event'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            matchBrandList: null,
            selectedMatchBrandId: null,
            locale: {}
        }
    },

    //--------------------------------------------------
    // component computed
    //--------------------------------------------------
    computed: {
        isMatchBrandListEmtpy() {
            return this.matchBrandList && (this.matchBrandList.length == 0)
        }
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        isItemSelected(item) {
            // console.log('isItemSelected', item.id, this.selectedOrganizationId)
            return item.id === this.selectedMatchBrandId
        },
        onMatchBrandItemClick(item) {
            console.log('onMatchBrandItemClick', item)
            this.$emit('custom-event', {
                type: 'itemClick',
                data: {
                    matchBrandId: item.id, 
                    matchBrandName: item.name, 
                    matchBrandLogoUrl: item.logoUrl, 
                    matchSessionMax: item.sessionMax, 
                    matchBrandArea: item.area, 
                    matchBrandAreaId: item.areaId 
                }
            })
        },
        onMoreBtnClick(item) {
            console.log('onMoreBtnClick', item)
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgDetailMatchBrand',
                    params: { id: item.id }
                }
            })
        },
        onCreateBtnClick() {
            console.log('onCreateBtnClick')
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgCreateMatchBrand'
                }
            })
        },
        //--------------------------------------------------
        // private method
        //--------------------------------------------------
        /**
         * @private
         * Adjust the image url according to the width and height.
         * @param img The identifier string for the image source.
         * @param w The image width number.
         * @param h The image height number.
         * @return The completed full url string.
         */
		adjustImageSize(img, w, h) {
            // console.log('adjustImageSize', img, w, h)
            if (img) {
                return QNImageUtil.imageView(img, w, h)
            }
			else {
                return null
            }
		},
    },
}
</script>

<template>
    <div class="match-brand-list">
        <div class="create-btn-wrapper">
            <div class="create-btn vertical-center justify-center" @click="onCreateBtnClick">
                <span class="main-text primary-color">{{ locale['create-match-brand'] }}</span>
            </div>
        </div>
        <div class="l-outer-margin b-outer-margin">
            <span class="main-text">{{ locale['history-match-brand-list'] }}</span>
        </div>
        <div v-if="!isMatchBrandListEmtpy">
            <van-list>
                <van-cell 
                    v-for="item in matchBrandList" 
                    :key="item.id" 
                    :class="{ 'item-selected': isItemSelected(item) }"
                    center
                    @click="onMatchBrandItemClick(item)"
                >
                    <template #title>
                        <van-row>
                            <van-col>
                                <van-image 
                                    v-if="item.logoUrl"
                                    :src="adjustImageSize(item.logoUrl, 120, 120)"
                                    fit="cover"
                                    round
                                    width="60px"
                                    height="60px"
                                />
                                <img
                                    v-else
                                    class="corner-round"
                                    src="@/assets/org/logo-symbol.png" 
                                    style="width: 60px; height: 60px;"
                                />
                            </van-col>
                            <van-col class="u-inner-margin">
                                <div>
                                    <span>{{ item.name }}</span>
                                </div>
                                <div>
                                    <span class="minor-text r-outer-margin">
                                        <span class="r-inner-margin">{{ item.sessionTotal }}</span>
                                        <span>{{ locale['session-unit'] }}{{ locale.match }}</span>
                                    </span>
                                    <span class="minor-text">
                                        <span class="r-inner-margin">{{ item.gameTotal }}</span>
                                        <span>{{ locale['game-unit'] }}{{ locale.game }}</span>
                                    </span>
                                </div>
                            </van-col>
                        </van-row>
                    </template>
                    <template #right-icon>
                        <van-icon 
                            name="more-o" 
                            size="24px"
                            @click.stop="onMoreBtnClick(item)"
                        />
                    </template>
                </van-cell>
            </van-list>
        </div>
        <div v-else @click="onCreateBtnClick">
            <van-empty 
                :description="locale['match-brand-empty-hint']"
                image="search"
            />
        </div>
    </div>
</template>

<style scoped>
.create-btn-wrapper {
    margin: 28px 10px 24px 10px;
}
.create-btn {
    background: #FFF;
    height: 46px;
    border-radius: 56px;
    border: 1px solid #4AA2F7;
}
</style>